import React from 'react';
import StandardTabContent from './StandardTabContent';

function PanoramaTabContent({ categoryPhotos, onImageClick }) {
  const renderBadge = () => (
    <div className="position-absolute top-0 start-0 m-2">
      <span className="badge bg-primary">360°</span>
    </div>
  );

  return (
    <StandardTabContent
      categoryPhotos={categoryPhotos}
      onImageClick={onImageClick}
      renderBadge={renderBadge}
    />
  );
}

export default PanoramaTabContent;